import React, { useState } from 'react';
import { Placemark } from 'react-yandex-maps';
import caption from 'assets/images/map/cluster.svg';
import './style.css';
import styles from './Point.scss';
import { useDispatch, useSelector } from 'react-redux';
import { loadPointList } from '../../../../actions/objects';
import { ROOT_URL } from '../../../../constants/Config';
import nothingFoundImage from 'assets/images/non-photo.png';
import { pluralize, formatNumber } from 'utils';
import { useTranslation } from 'react-i18next';

const truncateString = (str, maxLength = 20) =>
  str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;

const YClusterPoint = React.memo(({ lat, lng, pointCount, onClick, item }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);

  const [hovered, setHovered] = useState(false);

  const clusterPointIds = item.properties.clusteredPoints.map((obj) => Number(obj.id)) || [];

  const longLat = `${lng}-${lat}`;
  const longLatPoint = useSelector((state) => state.objects.pointsList[longLat]);

  const handleMouseEnter = () => {
    setHovered(true);
    if (!longLatPoint) {
      dispatch(loadPointList(clusterPointIds, longLat));
    }
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const pointData = longLatPoint ? longLatPoint[0] : {};

  const imageUrl = pointData
    ? pointData.image
      ? `${ROOT_URL}/image?id=${pointData.image.id}&size=small`
      : nothingFoundImage
    : '';

  return (
    <Placemark
      geometry={[+lat, +lng]}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      properties={{
        iconContent: `
        <div style="position: relative; display: flex; flex-direction: column; align-items: center;">
          ${
            hovered
              ? longLatPoint
                ? `<div class="${styles.iconContent}">
                  <div class="${styles.header}">
                    <div class="${styles.imageContainer}">
                      ${
                        imageUrl
                          ? `<img 
                              alt="house" 
                              class="${styles.image}" 
                              src="${imageUrl}"
                              />`
                          : ''
                      }
                    </div>
                    <div class="${styles.headerInfo}">
                      <div class="${styles.title}">
                        ${pointData && pointData.title ? truncateString(pointData.title, 23) : ''}
                      </div>
                      <div class="${styles.subtitle}">
                        ${
                          pointData && pointData.address
                            ? truncateString(pointData.address, 27)
                            : ''
                        }
                      </div>
                      <div class="${styles.labels}">
                        ${
                          pointData.view_action
                            ? `<div class="${styles.promo}">${t(
                                'components.common.yPlaceInfo.promo'
                              )}</div>`
                            : ''
                        }
                        ${
                          pointData.status === 3
                            ? `<div class="${styles.almostFinished}">${t(
                                'components.common.yPlaceInfo.almostFinished'
                              )}</div>`
                            : pointData.construction_finished
                            ? `<div class="${styles.finished}">${t(
                                'components.common.yPlaceInfo.finished'
                              )}</div>`
                            : `<div class="${styles.endDate}">
                                ${pointData.construction_ending} / ${pointData.year_built}
                              </div>`
                        }
                      </div>
                    </div>
                  </div>
                  <div class="${styles.footer}">
                  ${
                    pointData.count_flats
                      ? `<div class="${styles.footerLeft}">
                      <div class="${styles.flats}">
                        ${pointData.count_flats} ${pluralize(
                          pointData.count_flats,
                          t('components.common.yPlaceInfo.flat1'),
                          t('components.common.yPlaceInfo.flat2'),
                          t('components.common.yPlaceInfo.flat3')
                        )}
                      </div>
                      <div class="${styles.areas}">
                        ${pointData.min_square} м² - ${pointData.max_square} м²
                      </div>
                    </div>
                    <div class="${styles.footerRight}">
                      <div class="${styles.priceFrom}">
                        ${t('components.common.yPlaceInfo.square', {
                          minSquare: pointData.min_square,
                          maxSquare: pointData.max_square,
                        })}
                      </div>
                      <div class="${styles.pricePerMeter}">
                         ${t('components.common.yPlaceInfo.costMin', {
                           costMin: formatNumber(pointData.cost_min),
                           currency:
                             (pointData.country && pointData.country.country_currency_symbol) || '',
                         })}
                      </div>
                    </div>`
                      : `<div class="${styles.soldOut}">${t(
                          'components.common.yPlaceInfo.soldFlats'
                        )}</div>`
                  }
                  </div>  
                  <div class="${styles.objectCount}">
                   ${t('components.common.yPlaceInfo.andMore')} ${pointCount - 1} ${pluralize(
                    pointCount - 1,
                    t('components.common.yPlaceInfo.building1'),
                    t('components.common.yPlaceInfo.building2'),
                    t('components.common.yPlaceInfo.building3')
                  )}
                  </div>
                </div>`
                : `<div  class="${styles.iconContentLoading}">
                <span class="${styles.loader}"></span>
              </div>`
              : ''
          }
          <div class="ClusterPoint" 
            style="display: flex; align-items: center; justify-content: center;
            width: 34px; height: 34px; border: 3px solid #FFF; border-radius: 34px;
            background-color: #085286; text-align: center; line-height: 28px;
            font-size: 1.2rem; font-weight: 700; color: #FFF;
            box-shadow: 0 0 0.2rem rgba(0,0,0,0.3); transition: all 0.25s ease-in-out;">
            ${pointCount}
          </div>
        </div>`,
      }}
      onClick={onClick}
      options={{
        iconLayout: 'default#imageWithContent',
        iconImageSize: [34, 34],
        iconImageOffset: [-17, -17],
        iconImageHref: caption,
      }}
    />
  );
});

export default YClusterPoint;



// WEBPACK FOOTER //
// ./src/components/common/YMap/YClusterPoint/index.js